<template>
  <div>
    <page-intro>
      <template v-slot:heading>
        {{ request.topic }}
      </template>
    </page-intro>
    <div v-loading="$mip('getSupportRequestChat')" class="chat">
      <message-bubble
        v-for="message in request.chat"
        :key="message.id"
        class="mb-24"
        :message="message" />
    </div>

    <template v-if="!request.isClosed && ($store.state.user.accInfo.isAdmin || $store.state.user.accInfo.hasAccountAccess)">
      <el-input
        v-model="formData.newMessage"
        class="mt-12"
        type="textarea"
        :autosize="{ minRows: 4 }"
        placeholder="Новое сообщение" />
      <div class="flex mt-12 flex-y-start">
        <el-button
          :loading="$mip('sendSupportChatMessage')"
          class="mb-12 mr-12"
          size="medium"
          type="primary"
          icon="el-icon-s-promotion"
          @click="sendMessage">
          Отправить
        </el-button>
        <files-upload ref="filesUpload" @upload-complete="getChat" />
      </div>
    </template>
  </div>
</template>

<script>
  import PageIntro from '@/components/PageIntro.vue'
  import MessageBubble from './MessageBubble.vue'
  import { mapActions } from 'vuex'
  import FilesUpload from './FilesUpload.vue'

  export default {
    components: {
      PageIntro,
      MessageBubble,
      FilesUpload
    },

    data() {
      return {
        formData: {
          newMessage: '' // принимать переносы строк -> преобразовать к <br>
        },
        id: this.$route.params.supportRequestId,
        request: {}
      }
    },

    mounted() {
      this.getChat()
    },

    activated() {
      this.removeNotifications({
        removingMethod: 'readSupportChat',
        module: 'support',
        ids: [ this.id ]
      })
    },

    methods: {
      ...mapActions(['removeNotifications']),
      async sendMessage() {
        const message = this.formData.newMessage
        this.formData.newMessage = ''

        const { data: { associationId } } = await this.$http.sendSupportChatMessage({ message, id: this.id })
        this.$refs.filesUpload.startUploading(associationId)
      },

      async getChat() {
        const { data } = await this.$http.getSupportRequestChat({ id: this.id })
        this.request = data
      }
    }
  }
</script>